import { Avatar, Box, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import logo from "../../images/card_design.jpg";

const BooknowTopSection = ({ serviceDetails }) => {
  const {
    company,
    post_time,
    poster,
    pic,
    service_category,
    service_duration,
    service_info,
    poster_pic,
    agency_subtitle,
    price,
    agency_title,
    agency_logo,
    currency,
    jcategory,
    details,
    title,
  } = serviceDetails;
  return (
    <Stack sx={{ height: "73vh" }} justifyContent="center">
      <Stack
        justifyContent="space-between"
        alignItems={"flex-left"}
        spacing={2}
      >
        <Box sx={{ height: "100px" }}>
          <Box
            component="img"
            sx={{
              //   padding: "0 12px",
              height: "100%",
              cursor: "pointer",
              borderRadius: "8px",

              // display: { xs: "none", sm: "none", md: "block" },
            }}
            alt="The house from the offer."
            src={
              serviceDetails?.[0]?.service_pic?.[0]
                ? "//yeapbe.com/" +
                  serviceDetails?.[0]?.service_pic?.[0]?.pic_url
                : "https://aps.songjukti.com/image/web_admin/data_entry.jpg"
            }
          />
        </Box>
        <Typography variant="p" sx={{ fontSize: "12pt", fontWeight: 600 }}>
          {serviceDetails?.[0]?.title}
        </Typography>
        <Stack sx={{ width: "100%" }}>
          <Typography variant="p" sx={{ fontSize: "12pt", fontWeight: 600 }}>
            {serviceDetails?.[0]?.category?.[0]?.title}
          </Typography>
          <Typography variant="p" sx={{ fontSize: "11pt" }}>
            {serviceDetails?.[0]?.details}
          </Typography>
        </Stack>
        <Box sx={{ width: "15%" }}>
          <Typography
            variant="p"
            sx={{ fontSize: "13pt", fontWeight: 600, textAlign: "center" }}
          >
            {serviceDetails?.[0]?.currency == 1
              ? "BDT"
              : serviceDetails?.[0]?.currency == 2
              ? "USD"
              : serviceDetails?.[0]?.currency == 3
              ? "AED"
              : "BDT"}{" "}
            {serviceDetails?.[0]?.price}
          </Typography>
        </Box>
        <Paper sx={{ padding: "15px", width: "80%" }}>
          <Stack
            direction="row"
            justifyContent="left"
            alignItems={"center"}
            spacing={1}
          >
            <Avatar
              src={
                serviceDetails?.[0]?.agency_info?.agency_logo?.[0]
                  ? "//yeapbe.com/" +
                    serviceDetails?.[0]?.agency_info?.agency_logo?.[0]?.pic_url
                  : "//yeapbe.com/" +
                    serviceDetails?.[0]?.poster_info?.user_pic?.[0]?.pic_url
              }
              sx={{ width: "40px", height: "40px" }}
            ></Avatar>
            <Stack>
              <Typography
                variant="p"
                sx={{ fontSize: "11pt", fontWeight: 600 }}
              >
                {serviceDetails?.[0]?.agency_info?.cname
                  ? serviceDetails?.[0]?.agency_info?.cname
                  : serviceDetails?.[0]?.poster_info?.Name}
              </Typography>
              <Typography variant="p" sx={{ fontSize: "11pt" }}>
                {serviceDetails?.[0]?.agency_info?.cslogan
                  ? serviceDetails?.[0]?.agency_info?.cslogan
                  : serviceDetails?.[0]?.poster_info?.Location}
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      </Stack>
    </Stack>
  );
};

export default BooknowTopSection;
